var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 60,
    viewBox: "0 0 57 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.85025 0L0 10.2676V51.3331H14.1111V59.0376H21.8149L29.5114 51.3331H41.0591L56.4592 35.9385V0H3.85025ZM8.97988 5.13051H51.3272V33.3665L42.3424 42.3517H28.2296L20.5355 50.0458V42.3519H8.97988V5.13051ZM23.0965 30.8029H28.2296V15.4037H23.0965V30.8029ZM37.2106 30.8029H42.3426V15.4037H37.2106V30.8029Z",
    fill: "#5A3E85"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.4592,
    height: 59.1057,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitchIcon);
export default __webpack_public_path__ + "static/media/twitch-icon.5f45b2677f90b67909939da95e3934cf.svg";
export { ForwardRef as ReactComponent };